module.exports = __webpack_public_path__ + "img/020.161b70be.png";